import { Accessor, Setter, Show } from "solid-js";
import { zIndexes } from "~/z_indexes";
import { Mode } from "~/types";
import { HeaderMenu } from "../header_menu";
import { A } from "@solidjs/router";
import { openIntercom } from "~/utils/third_party/intercom";
import { closeIconSM, dropdownList } from "~/assets/assets";

type HeaderProps = {
  mode: Mode;
  isLoggedIn: () => boolean;
  isSearchActive?: Accessor<boolean>;
  isDropdownOpen?: Accessor<boolean>;
  setIsDropdownOpen?: Setter<boolean>;
  clientLogoUrl: string;
  clientId?: string;
};

export const GodrejPropertiesHeader = ({
  isLoggedIn,
  mode,
  isSearchActive,
  isDropdownOpen,
  setIsDropdownOpen,
  clientLogoUrl,
  clientId,
}: HeaderProps) => {
  return (
    <div class="relative w-full">
      <div
        class={`${isLoggedIn() ? "sticky" : "fixed"} top-0 h-[64px] w-full border-b border-[#333232] bg-[#3555FF] pb-16`}
        style={{
          "z-index": zIndexes.header,
        }}
      >
        <div
          class={`fixed left-0 right-0  h-screen w-full bg-[#212427] transition-all duration-300 darkTheme:bg-[#212427] md:top-24 ${isDropdownOpen?.() ? "opacity-60" : "pointer-events-none opacity-0"} ${isSearchActive?.() ? "top-28" : "top-24"}`}
        />
        <div class="h-full w-full bg-[#3555FF]">
          <div class="fixed mx-auto flex h-[64px] w-full items-center justify-between gap-1 bg-[#3555FF] p-4 md:w-[1440px] md:gap-0 md:px-[152px] md:py-4 lg:w-full">
            <div class="md:hidden">
              <DropDown />
            </div>

            <div class="flex w-full items-center justify-between">
              <A href="/" class="">
                <img src={clientLogoUrl} alt="" class="h-[85px] w-[270px]" />
              </A>

              <div class="hidden sm:block">
                <DesktopButtons />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  function DropDown() {
    return (
      <>
        <div
          class="flex min-h-7 min-w-7 cursor-pointer items-center"
          onClick={() => {
            setIsDropdownOpen?.(!isDropdownOpen?.());
          }}
        >
          <Show
            when={isDropdownOpen?.()}
            fallback={
              <img
                src={dropdownList}
                class="min-h-7 min-w-7"
                alt="dropdown list"
              />
            }
          >
            <img src={closeIconSM} class="max-h-7 max-w-7" alt="close" />
          </Show>
        </div>

        <HeaderMenu
          isDropdownOpen={isDropdownOpen!}
          setIsDropdownOpen={setIsDropdownOpen!}
          isLoggedIn={isLoggedIn()}
          mode={mode}
          clientId={() => clientId!}
        />
      </>
    );
  }

  function DesktopButtons() {
    return (
      <div class="flex justify-end gap-5 md:mr-8 xl:mr-0">
        <p
          class="cursor-pointer text-mediumBold text-white"
          onClick={() => {
            openIntercom();
          }}
        >
          Contact support
        </p>
        <A
          href="https://www.myhubble.money/terms-and-conditions"
          target="_blank"
        >
          <p class="cursor-pointer text-mediumBold text-white">
            Terms & conditions
          </p>
        </A>
        <Show when={isLoggedIn()}>
          <A href="/profile">
            <p class="cursor-pointer text-mediumBold text-white">
              My gift cards
            </p>
          </A>
          <A href="/logout">
            <p class="cursor-pointer text-mediumBold text-white">Logout</p>
          </A>
        </Show>
      </div>
    );
  }
};
